var _mask, _path, _path2, _path3, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3126_1253",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7391 12.5202H36.1478L33.613 8.69409C32.6565 7.25931 30.9826 6.39844 29.2609 6.39844H18.7391C17.0174 6.39844 15.3435 7.25931 14.387 8.69409L11.8522 12.5202H7.26087C4.34348 12.5202 2 14.8637 2 17.781V36.3376C2 39.255 4.34348 41.5984 7.26087 41.5984H40.7391C43.6565 41.5984 46 39.255 46 36.3376V17.781C46 14.8637 43.6565 12.5202 40.7391 12.5202Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1478 12.5202L34.4805 13.6248L35.0737 14.5202H36.1478V12.5202ZM33.613 8.69409L35.2803 7.5895L35.2771 7.58469L33.613 8.69409ZM14.387 8.69409L12.7228 7.58468L12.7197 7.5895L14.387 8.69409ZM11.8522 12.5202V14.5202H12.9263L13.5195 13.6248L11.8522 12.5202ZM36.1478 14.5202H40.7391V10.5202H36.1478V14.5202ZM31.9457 9.79868L34.4805 13.6248L37.8151 11.4156L35.2803 7.5895L31.9457 9.79868ZM29.2609 8.39844C30.341 8.39844 31.3781 8.94728 31.9489 9.80349L35.2771 7.58469C33.9349 5.57134 31.6242 4.39844 29.2609 4.39844V8.39844ZM18.7391 8.39844H29.2609V4.39844H18.7391V8.39844ZM16.0511 9.80349C16.6219 8.94728 17.659 8.39844 18.7391 8.39844V4.39844C16.3758 4.39844 14.0651 5.57134 12.7229 7.58469L16.0511 9.80349ZM13.5195 13.6248L16.0543 9.79868L12.7197 7.5895L10.1849 11.4156L13.5195 13.6248ZM7.26087 14.5202H11.8522V10.5202H7.26087V14.5202ZM4 17.781C4 15.9682 5.44805 14.5202 7.26087 14.5202V10.5202C3.23891 10.5202 0 13.7591 0 17.781H4ZM4 36.3376V17.781H0V36.3376H4ZM7.26087 39.5984C5.44805 39.5984 4 38.1504 4 36.3376H0C0 40.3595 3.23891 43.5984 7.26087 43.5984V39.5984ZM40.7391 39.5984H7.26087V43.5984H40.7391V39.5984ZM44 36.3376C44 38.1504 42.552 39.5984 40.7391 39.5984V43.5984C44.7611 43.5984 48 40.3595 48 36.3376H44ZM44 17.781V36.3376H48V17.781H44ZM40.7391 14.5202C42.552 14.5202 44 15.9682 44 17.781H48C48 13.7591 44.7611 10.5202 40.7391 10.5202V14.5202Z",
    fill: "#7663EB",
    mask: "url(#path-1-inside-1_3126_1253)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16C29.5117 16 34 20.4383 34 25.96C34 31.4911 29.5023 36 24 36C18.4883 36 14 31.5617 14 26.04C14 20.5089 18.4977 16 24 16Z",
    stroke: "#7663EB",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16C29.5117 16 34 20.4383 34 25.96C34 31.4911 29.5023 36 24 36C18.4883 36 14 31.5617 14 26.04C14 20.5089 18.4977 16 24 16Z",
    stroke: "#7663EB",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.75,
    y: 17.75,
    width: 2.5,
    height: 1.5,
    rx: 0.75,
    stroke: "#7663EB",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera1);
export default __webpack_public_path__ + "static/media/camera-1.dea1b8b2aa9dc05bc2ea4d6755e9fd7b.svg";
export { ForwardRef as ReactComponent };